module.exports = __webpack_public_path__ + "img/forefoot_strike.299c4a5f.svg";